<template>
    <ul class="dropdown-actions dropdown-menu shadow-md">
        <!-- Edit appointment -->
        <li v-if="canEditBooking">
            <a href="" @click.prevent="editBooking">
                <i class="zmdi zmdi-edit"></i>
                <span>{{ trans('calendar.edit_booking_title') }}</span>
            </a>
        </li>
        <!-- View client -->
        <li v-if="canSeeClient && booking.client">
            <a :href="`/app/client/${booking.client.id}`">
                <i class="zmdi zmdi-arrow-right"></i>
                <span>{{ trans('clients.goto') }}</span>
            </a>
        </li>
        <!-- Edit client -->
        <li v-if="canEditClient">
            <a href="" @click.prevent="editClient">
                <i class="zmdi zmdi-account"></i>
                <span>{{ booking.client ? trans('calendar.edit_client') : trans('clients.groups.edit')}}</span>
            </a>
        </li>
        <!-- View journal -->
        <li v-if="canSeeClient && isJournalActive && canSeeJournal">
            <a href="" @click.prevent="showJournal">
                <i class="zmdi zmdi-book"></i>
                <span>{{ trans('calendar.view_journal') }}</span>
            </a>
        </li>
        <!-- Add survey -->
        <li v-if="canAddSurvey">
            <a href="" @click.prevent="addSurvey">
                <i class="zmdi zmdi-assignment-o"></i>
                <span>{{ trans('surveys.add_survey') }}</span>
            </a>
        </li>
        <!-- Appointment history -->
        <li v-if="canSeeHistory">
            <a href="" @click.prevent="viewHistory">
                <i class="zmdi zmdi-time-restore"></i>
                <span>{{ trans('online_booking.appointment_history') }}</span>
            </a>
        </li>
    </ul>
</template>

<script>
import { mapStores } from 'pinia';
import { useCalendarSidebarStore, SidebarViews } from 'Components/calendar/calendar_sidebar/store/calendarSidebarStore';
import Apps from '@/core/Apps'

export default {
    props: {
        booking: {
            type: Object,
            required: true,
        },
        calendar_sidebar_enabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        reset() {
            this.$emit('option-selected')
        },
        editBooking() {
            if (this.calendar_sidebar_enabled) {
                this.calendarSidebarStore.navigateTo(SidebarViews.CREATE_CLIENT_BOOKING, { booking: this.booking, load: true, mode: 'edit' });
            } else {
                this.$event_bus.$emit('showEditClientBooking', this.booking, true)
            }
            this.reset()
        },
        addSurvey() {
            this.$event_bus.$emit('addSurveyToBooking', this.booking)
            this.reset()
        },
        showJournal() {
            if (this.booking.client) {
                this.$emit('show-journal', this.booking);
            } else {
                this.$event_bus.$emit('showClientGroupJournalModal', this.booking.client_group);
            }

            this.reset()
        },
        editClient() {
            if (this.booking.client) {
                if (this.calendar_sidebar_enabled) {
                    this.calendarSidebarStore.navigateTo(SidebarViews.EDIT_CLIENT, { client: this.booking.client });
                } else {
                    this.$event_bus.$emit('showEditClient', this.booking.client);
                }
            } else {
                this.$event_bus.$emit('showEditClientGroupModal', this.booking.client_group);
            }
            
            this.reset();
        },
        viewHistory() {
            this.$event_bus.$emit('showBookingHistory', this.booking);
            this.reset()
        }
    },
    computed: {
        isJournalActive() {
            return this.$store.getters['apps/isAppEnabled'](Apps.Journal);
        },
        isSurveysActive() {
            return this.$store.getters['apps/isAppEnabled'](Apps.Surveys);
        },
        canSeeClient() {
            return this.booking.client
                ? this.$can('see', 'client', this.booking.client)
                : this.$can('see', 'clientGroup', this.booking.client_group);
        },
        canEditClient() {
            return this.booking.client
                ? this.$can('edit', 'client', this.booking.client)
                : this.$can('edit', 'clientGroup', this.booking.client_group);
        },
        canSeeJournal() {
            return this.$can('see', 'journals');
        },
        canEditBooking() {
            const calendar = this.$store.getters['calendars/getCalendarById'](this.booking.calendar_id);
            return calendar && calendar.can_edit;
        },
        canAddSurvey() {
            return this.isSurveysActive && this.$can('see-surveys')
        },
        canSeeHistory() {
            return this.$canEither('see-logs', 'see-logsassigned')
        },
        ...mapStores(useCalendarSidebarStore),
    }
}
</script>
